<template>
  <tooltip text="This file is more than a week old">
    <span role="img" aria-label="File is more than a week old" tabindex="0">
      <i class="fa fa-exclamation-circle stale-icon" aria-hidden="true"></i>
    </span>
  </tooltip>
</template>

<script>
import { Tooltip } from 'uiv'

export default {
  name: 'StaleFileIcon',
  components: { Tooltip }
}
</script>

<style scoped>
@import '../../styles/foundations.css';

.stale-icon {
  color: var(--amber-400);
  font-size: 12px;
  cursor: default;
  display: flex;
  align-items: center;
  line-height: 1;
}
</style>
